<template>
  <absence-show :currentAbsence="currentAbsence" />
</template>

<script>
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';

import AbsenceShow from '../AbsenceShow.vue';

export default {
  components: {
    AbsenceShow,
  },
  data() {
    return {
      title: 'Gestion des absences - Détails',
    };
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  computed: {
    ...mapGetters('absence', ['currentAbsence']),
  },
  methods: {
    ...mapActions('absence', ['getAbsence']),
    init() {
      if (!this.currentAbsence) {
        this.getAbsence({ id: this.$route.params.id });
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
